import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { handleRequest } from '../quipli-service-client';
import { AxiosRequestConfig } from 'axios';
import { ImportResult } from './import-export';

export const useImportExportApi = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  async function exportParts(): Promise<BlobPart> {
    const config: AxiosRequestConfig = {
      method: 'get',
      url: `${contextPath}quipli-service/v1/importExport/export/parts`,
      headers: {
        'X-Tenant': tenant,
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      },
      responseType: 'blob',
    };
    return await handleRequest(config, true);
  }

  async function exportPartsSample(): Promise<BlobPart> {
    const config: AxiosRequestConfig = {
      method: 'get',
      url: `${contextPath}quipli-service/v1/importExport/sample/parts`,
      headers: {
        'X-Tenant': tenant,
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      },
      responseType: 'blob',
    };
    return await handleRequest(config, true);
  }

  async function importParts(file: File, isStockAdditive: boolean): Promise<ImportResult> {
    const data = new FormData();
    data.append('file', file);
    data.append('isStockAdditive', isStockAdditive.toString());

    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/importExport/import/parts`,
      headers: {
        'X-Tenant': tenant,
      },
      data: data,
      cache: false,
      contentType: false,
      processData: false,
      mimeType: 'multipart/form-data',
    };

    return await handleRequest(config, true);
  }

  async function exportLocationServices(locationId: number): Promise<BlobPart> {
    const config: AxiosRequestConfig = {
      method: 'get',
      url: `${contextPath}quipli-service/v1/importExport/export/services/${locationId}`,
      headers: {
        'X-Tenant': tenant,
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      },
      responseType: 'blob',
    };
    return await handleRequest(config, true);
  }

  async function exportLocationServicesSample(): Promise<BlobPart> {
    const config: AxiosRequestConfig = {
      method: 'get',
      url: `${contextPath}quipli-service/v1/importExport/sample/services`,
      headers: {
        'X-Tenant': tenant,
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      },
      responseType: 'blob',
    };
    return await handleRequest(config, true);
  }

  async function importLocationServices(locationId: number, file: File): Promise<ImportResult> {
    const data = new FormData();
    data.append('file', file);

    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/v1/importExport/import/services/${locationId}`,
      headers: {
        'X-Tenant': tenant,
      },
      data: data,
      cache: false,
      contentType: false,
      processData: false,
      mimeType: 'multipart/form-data',
    };

    return await handleRequest(config, true);
  }

  async function exportCustomerPricing(userId: number): Promise<BlobPart> {
    const config: AxiosRequestConfig = {
      method: 'get',
      url: `${contextPath}quipli-service/v1/importExport/export/prices/user/${userId}`,
      headers: {
        'X-Tenant': tenant,
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      },
      responseType: 'blob',
    };
    return await handleRequest(config, true);
  }

  return {
    exportParts,
    exportPartsSample,
    importParts,
    exportLocationServices,
    exportLocationServicesSample,
    importLocationServices,
    exportCustomerPricing,
  };
};
